// -----------------  FETCH PRODUCT GALLERY -----------------
export const FETCH_ASSET_GROUPS_LOADING = 'FETCH_ASSET_GROUPS_LOADING';
export const FETCH_ASSET_GROUPS_SUCCESS = 'FETCH_ASSET_GROUPS_SUCCESS';
export const FETCH_ASSET_GROUPS_ERROR = 'FETCH_ASSET_GROUPS_ERROR';

// -----------------  CLEAR PRODUCT GALLERY -----------------
export const CLEAR_PRODUCT_ASSET_GROUPS = 'CLEAR_PRODUCT_ASSET_GROUPS';
